module.exports = __webpack_public_path__ + "static/assets/209a7f576efbee3b9824840b3dc8c446.ttf";